import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="flex-1 w-full flex flex-col items-center justify-center text-center px-4 py-24">
      <span className="w-16 h-16 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center">
        <i className="ri-emotion-sad-line text-3xl"></i>
      </span>
      <h1 className="mt-6 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md">
        你要找的漫画页面不存在或已被移动，回到首页继续探索更多精彩故事吧。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50 border border-background-300 text-foreground-800 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-layout-grid-line"></i>
          去逛分类
        </Link>
      </div>
    </main>
  );
}